import React, { useState, useEffect } from 'react';
import './App.css';
import SendMessage from './components/SendMessage';
import Navigation from './components/Navigation';
import ServerStatus from './components/ServerStatus';
import SavedMessages from './components/SavedMessages';

function ComingSoon() {
  return (
    <div className="coming-soon">
      <h2>Coming Soon</h2>
      <p>This feature is under development and will be available soon.</p>
    </div>
  );
}

function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [user, setUser] = useState(null);
  const [error, setError] = useState(null);
  const [activeSection, setActiveSection] = useState('servers');

  useEffect(() => {
    // Check authentication status on mount
    fetch('/is_authenticated', {
      credentials: 'include',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
      .then(response => {
        console.log('Auth check response status:', response.status);
        if (response.status === 401) {
          return { authenticated: false };
        }
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }
        return response.json();
      })
      .then(data => {
        console.log('Auth check response data:', data);
        if (data && data.authenticated) {
          setIsLoggedIn(true);
          setUser(data.user);
        } else {
          setIsLoggedIn(false);
          setUser(null);
        }
      })
      .catch(error => {
        console.error('Error checking authentication:', error);
        setIsLoggedIn(false);
        setUser(null);
      });
  }, []);

  const handleLogin = () => {
    window.location.href = '/login';
  };

  const handleLogout = () => {
    fetch('/logout', {
      credentials: 'include',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
      .then(() => {
        setIsLoggedIn(false);
        setUser(null);
        setActiveSection('servers');
      })
      .catch(error => {
        console.error('Error logging out:', error);
        setError('Failed to log out');
      });
  };

  const renderSection = () => {
    if (!isLoggedIn) {
      return (
        <div className="public">
          <h2>Please log in to access the application</h2>
        </div>
      );
    }

    switch (activeSection) {
      case 'servers':
        return <ServerStatus />;
      case 'contacts':
        return <SendMessage />;
      case 'test-data':
        return <SavedMessages />;
      case 'predictor':
      case 'vessel':
        return <ComingSoon />;
      default:
        return <ServerStatus />;
    }
  };

  if (error) {
    return <div className="error">{error}</div>;
  }

  return (
    <div className="App">
      <Navigation 
        activeSection={activeSection}
        onSectionChange={setActiveSection}
        isLoggedIn={isLoggedIn}
        onLogin={handleLogin}
        onLogout={handleLogout}
      />
      <div className="content">
        {renderSection()}
      </div>
    </div>
  );
}

export default App;
